import React, { FC } from 'react'
import AchCreditContainer from 'containers/AchCredit'

const AchCreditPage: FC = () => <AchCreditContainer />

export default AchCreditPage
